import S from './HealthStyles';

function Health(): JSX.Element {
  return (
    <S.Wrapper>
      <div> App is working! </div>
    </S.Wrapper>
  );
}

export default Health;
